import React, { useContext, useEffect, useState } from 'react';
import { useLocalizedStrings } from '../../Localization';
import { AdminPanelPage } from '../AdminPanelPage';
import { Button, Card, CardHeader, Icon } from '@aidkitorg/component-library';
import { ConfigurationContext, PublicConfigurationContext } from '../../Context';
import { ProgramContacts } from './components/ProgramContacts';
import { ProgramAssistant, ProgramAssistantSafe } from './components/ProgramAssistant';
import { ReportTechnicalIssueModal } from './components/ReportTechnicalIssueModal';
import { useProgramHome } from '../../Contexts/ProgramHomeContext';
import { WhatsNew } from './components/WhatsNew';

export const ProgramHomePage = () => {
  const L = useLocalizedStrings()
  const config = useContext(ConfigurationContext);
  const publicConfig = useContext(PublicConfigurationContext);
  const [isReportIssueModalOpen, setIsReportIssueModalOpen] = useState(false);
  const { programHomeData, isProgramHomeLoading, fetchProgramHome } = useProgramHome();

  const showAdminPanelHome = publicConfig.showAdminPanelHome
  const programDocumentationLink = publicConfig.programDocumentationLink
  const enableAdminPanelProgramAssistant = publicConfig.enableAdminPanelProgramAssistant

  // Fetch program home data on mount
  useEffect(() => {
    if (showAdminPanelHome) {
      fetchProgramHome();
    }
  }, [showAdminPanelHome, fetchProgramHome]);

  const quickActions = <Card className="p-1 w-full rounded-md">
    <CardHeader
      title={<div className='font-bold text-xl'>{L.admin_panel.program_home.quick_actions.title}</div>}
    />
    <div>
      <div className="flex flex-col gap-y-4 pt-3">
        <Button
          variant="secondary"
          className="border !w-full !justify-start"
          onClick={() => setIsReportIssueModalOpen(true)}
        >
          <div className="flex items-center gap-x-3">
            <div>
              <Icon className='text-[var(--ak-identity-color-red)]' type="solid" name="BugAntIcon" role="decorative"/>
            </div>
            <div className="text-left">
              {L.admin_panel.program_home.quick_actions.report_technical_issue}
            </div>
          </div>
        </Button>
        {programDocumentationLink && (
          <a
            href={programDocumentationLink}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center rounded text-sm font-bold py-[0.5rem] px-[0.75rem] transition-colors duration-300 !w-full !justify-start"
            style={{
              backgroundColor: 'var(--ak-color-button-secondary-background)',
              border: 'var(--ak-color-button-secondary-border)',
              color: 'var(--ak-color-button-secondary-text)'
            }}
            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'var(--ak-color-button-secondary-background-hover)'}
            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'var(--ak-color-button-secondary-background)'}
          >
            <div className="flex items-center gap-x-3">
              <div>
                <Icon className="text-[var(--ak-identity-color-blue)]" type="solid" name="BookOpenIcon" role="decorative"/>
              </div>
              <div className="text-left">
                {L.admin_panel.program_home.quick_actions.program_documentation}
              </div>
            </div>
          </a>
        )}
      </div>
    </div>
    <ProgramContacts/>
  </Card>

  return (
    <>
      <AdminPanelPage
        title={L.admin_panel.program_home.welcome.replace('{name}', config.user.name)}
        breadcrumbs={[
          {
            label: L.admin_panel.nav.home
          }
        ]}
      >
        {showAdminPanelHome ? (
          <div className="w-full">
            <div className="w-full pb-4">
              <WhatsNew programHomeData={programHomeData} isProgramHomeLoading={isProgramHomeLoading} />
            </div>
            <div className="w-full">
              <div className="grid grid-cols-1 lg:grid-cols-7 gap-6">
                {/* Render the safe skeleton version of the program assistant when we haven't enabled the 
                live version yet for a program. */}
                <div className="lg:col-span-4">{enableAdminPanelProgramAssistant ? <ProgramAssistant /> : <ProgramAssistantSafe />}</div>
                <div className="lg:col-span-3">{quickActions}</div>
              </div>
            </div>
          </div>
        ) : <></>}

      </AdminPanelPage>

      <ReportTechnicalIssueModal
        open={isReportIssueModalOpen}
        onClose={() => setIsReportIssueModalOpen(false)}
      />
    </>
  )
}